import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon, { GLYPHS } from '../../icon';
import Input from './Input';

class Button extends Input {
  static propTypes = {
    iconSize: PropTypes.oneOf(['', 'medium']),
    buttonType: PropTypes.oneOf(['bare', 'blank']).isRequired,
  }
  static defaultProps = {
    iconSize: null,
  }
  render() {
    return (
      <button
        type="button"
        className={cx('c-btn u-ph--', `c-btn--${this.props.buttonType}`)}
        {...this.getInputProps()}
        ref={(ref) => { this.el = ref; }}
      >
        <Icon glyph={GLYPHS.calendar} size={this.props.iconSize} />
      </button>
    );
  }
}

export default Button;
